import { render, staticRenderFns } from "./wechat-layout.vue?vue&type=template&id=74919c72&scoped=true&"
import script from "./wechat-layout.vue?vue&type=script&lang=js&"
export * from "./wechat-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74919c72",
  null
  
)

export default component.exports